<div #outerDiv>
  @if (fileSelectOptions$ | async; as fileSelectOptions) {
    <div>
      <div
        ngFileDrop
        class="drop-container text-center"
        [ngClass]="{ 'd-none': state !== UploaderState.selectFile, 'is-drop-over': dragOver }"
        [options]="fileSelectOptions"
        (uploadOutput)="onUploadOutput($event)"
        [uploadInput]="uploadInput">
        <label
          class="drop-container__input-field"
          [for]="fieldId">
          @if (state === UploaderState.selectFile) {
            <div class="drop-container__title">{{ title }}</div>
            <p class="drop-container__text">
              {{ text }}
              @if (destinationInfo) {
                <i
                  [ngbTooltip]="tipContent"
                  class="ms-1 iconoir-info-circle">
                </i>
              }
            </p>
            @if (textExtra) {
              <p class="drop-container__text">
                {{ textExtra }}
              </p>
            }
            <ng-template #tipContent>
              <bo-file-requirements [destinationInfo]="destinationInfo"></bo-file-requirements>
            </ng-template>
          }
          <input
            #fileInput
            type="file"
            ngFileSelect
            [id]="fieldId"
            class="drop-container__input-field"
            [options]="fileSelectOptions"
            (uploadOutput)="onUploadOutput($event)"
            [uploadInput]="uploadInput" />
          <div class="text-center">
            <div class="btn btn-light">Choose a file</div>
          </div>
        </label>
      </div>
      @if (state === UploaderState.crop) {
        <div class="cropping-container">
          <img-cropper
            [image]="cropperData"
            [inputImage]="image"
            [settings]="cropperSettings"></img-cropper>
          <!-- Rotation controls -->
          <div class="row justify-content-center align-items-center my-3">
            <div class="col-auto">
              <button
                type="button"
                class="btn-action"
                [disabled]="isRotating"
                (click)="rotateLeft()"
                title="Rotate left 90°">
                <i class="pays-svg-icon ic-rotate-left"></i>
              </button>
            </div>
            <div class="col-auto">
              <button
                type="button"
                class="btn-action"
                [disabled]="isRotating"
                (click)="rotateRight()"
                title="Rotate right 90°">
                <i class="pays-svg-icon ic-rotate-right"></i>
              </button>
            </div>
            <div class="col-auto">
              <button
                class="btn btn-light btn-sm"
                (click)="reset()">
                Reset
              </button>
            </div>
            <div class="col-auto">
              <button
                class="btn btn-primary btn-sm"
                [disabled]="submitDisabled()"
                (click)="upload()">
                Accept
              </button>
            </div>
          </div>
        </div>
      }
      @if (state === UploaderState.uploading && files.length > 0) {
        @for (f of files; track f) {
          <div class="upload-item">
            <p class="mb-2 small">Uploading file</p>
            @if (f.progress.data) {
              @if (f.progress.data) {
                <ngb-progressbar
                  class="mb-3"
                  type="secondary"
                  [animated]="true"
                  [value]="f.progress.data!.percentage" />
              }
            }
          </div>
        }
      }
      @if (error) {
        <alert
          [dismissible]="false"
          type="danger">
          {{ error }}
        </alert>
      }
    </div>
  } @else {
    <div class="loader drop-container">
      <svg
        class="loader-circular"
        viewBox="25 25 50 50">
        <circle
          class="loader-path"
          cx="50"
          cy="50"
          r="20"
          fill="none"
          stroke-width="2"
          stroke-miterlimit="10"></circle>
      </svg>
    </div>
  }
</div>
